import { useMessages } from '@/i18n/LocaleProvider';
import messages from '@/i18n/catalogs/corporate/AnnouncementBar';
import { useEffect, useState } from 'react';

import { Link } from '@/i18n/router';
import { ArrowRight, X } from 'lucide-react';
import { CLOUD_LAUNCH_PROMO } from '@/data/cloud';

// Bump the key when the announcement changes so a previous dismissal doesn't hide the new one.
const DISMISS_KEY = 'announcement-dismissed:hardcharger-launch';

// Site-wide launch bar, rendered above the sticky navbar. It is in the prerendered
// HTML for everyone; a saved dismissal hides it after hydration.
const AnnouncementBar = () => {
  const m = useMessages(messages);


  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY)) setDismissed(true);
    } catch {
      // Storage unavailable (private mode, blocked site data) — keep showing the bar.
    }
  }, []);

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Ignore — the bar just returns on the next page load.
    }
  };

  return (
    <div className="relative bg-hc-navy text-white">
      <div className="max-w-7xl mx-auto px-10 py-2 text-center text-sm">
        <Link
          to="/hardcharger"
          className="inline-flex flex-wrap items-center justify-center gap-x-2 font-medium hover:underline underline-offset-4"
          data-ga-cta="hardcharger_launch"
          data-ga-location="announcement_bar"
        >
          <span className="rounded-full bg-white/15 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide">{m.s1}</span>
          <span>{m.s2}<span className="hidden sm:inline">{m.s3}{CLOUD_LAUNCH_PROMO.creditUsd}{m.s4}</span>
          </span>
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <button
        type="button"
        onClick={dismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-white/80 hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
        aria-label={m.s5}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
